import { useQuery } from '@tanstack/react-query';
import { authApi } from '@/common/api/authApi';
import { clearSilentLogin } from '@/common/utils/silentLogin';

export type AuthSessionUser = { sub: string; email?: string; name?: string; picture?: string };
export type AuthSession = { isAuthenticated: boolean; user?: AuthSessionUser };
export type AuthSessionState = {
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: AuthSessionUser;
};

export const EMPTY_SESSION: AuthSession = { isAuthenticated: false };

export const authSessionQueryKey = () => ['authSession'];

const fetchAuthSession = async (): Promise<AuthSession> => {
  const response = await authApi.me.$get();
  if (!response.ok) return EMPTY_SESSION;
  const session: AuthSession = await response.json();
  if (session.isAuthenticated) clearSilentLogin();
  return session;
};

export const useAuthSession = (): AuthSessionState => {
  const { data, isLoading } = useQuery({
    queryKey: authSessionQueryKey(),
    queryFn: fetchAuthSession,
    staleTime: 60_000,
  });

  return {
    isAuthenticated: data?.isAuthenticated ?? false,
    isLoading,
    user: data?.user,
  };
};
